
<i18n lang="json">
    {
      "ru": {
        "Аверс": "Аверс",
        "Реверс":"Реверс"
      },
      "en": {
        "Аверс": "The obverse",
        "Реверс":"the reverse"
      },
      "ab": {
        "Аверс": "Ахаҿратә ган",
        "Реверс":"Ашьҭахьтәи аган"
      },
      "es": {
        "Аверс": "The obverse",
        "Реверс":"the reverse"
      },
      "tr": {
        "Аверс": "Ön yüzü",
        "Реверс":"Arka yüzü"
      },
      "ar": {
        "Аверс": "The obverse",
        "Реверс":"the reverse"
      },
      "zh": {
        "Аверс": "The obverse",
        "Реверс":"the reverse"
      }
    }
    </i18n>
    
    <script setup>
    const props = defineProps({
      obverse: {
        type: Object,
        required: true,
      },
      reverse: {
        type: Object,
        required: true,
      },
    });
    
    const selected = ref("obverse");
    
    const { t } = useI18n({ useScope: "local" });
    </script>
    
    <template>
      <div class="product-item__galery">
        <div class="galery-big-image" :class="selected">
          <img
            loading="lazy"
            :src="obverse.url"
            :alt="obverse.caption"
            class="front-side"
          />
          <img
            loading="lazy"
            :src="reverse.url"
            :alt="reverse.caption"
            class="rear-side"
          />
        </div>
        <div class="galery__pagination space-x-[50px]">
          <div
            class="pagination__block"
            :class="selected == 'obverse' ? 'active' : ''"
          >
            <div class="pagination__img">
              <img
                :src="obverse.url"
                :alt="obverse.caption"
                @click="selected = 'obverse'"
                @mouseover="selected = 'obverse'"
              />
            </div>
            <span class="block font-firasans text-center pt-1 text-lg">{{ t("Аверс") }}</span>
          </div>
          <div
            class="pagination__block"
            :class="selected == 'reverse' ? 'active' : ''"
          >
            <div class="pagination__img">
              <img
                :src="reverse.url" 
                :alt="reverse.caption"
                @click="selected = 'reverse'"
                @mouseover="selected = 'reverse'"
              />
            </div>
            <span class="block font-firasans text-center pt-1 text-lg">{{ t("Реверс") }}</span>
          </div>
        </div>
      </div>
    </template>
    
    <style  scoped>
    .product-item__galery {
      max-width: 410px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .galery-big-image {
      mix-blend-mode: darken;
      position: relative;
      overflow: hidden;
      border-radius: 50%;
      width: 181px;
      height: 181px;
    }
    .pagination__block {
        transition: all 0.3s ease;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        opacity: 0.6;
    }
    
    .pagination__block.active {
      opacity: 1;
    }
    
    .galery-big-image img {
      transition: all 0.5s ease 0.2s;
      position: absolute;
      width: 100%;
      height: 100%;
      -o-object-fit: cover;
      object-fit: cover;
      -o-object-position: center center;
      object-position: center center;
    }
    
    .galery__pagination {
      display: flex;
      margin-top: 1px;
    }
    
    .pagination__img {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 84px;
      height: 84px;
    }
    
    .pagination__img img {
      -o-object-fit: contain;
      border-radius: 100%;
      object-fit: contain;
      width: 100%;
      height: auto;
    }
    
    .obverse .front-side {
      transform: translateZ(0);
      opacity: 1;
    }
    
    .obverse .rear-side {
      opacity: 0;
      transform: rotateY(180deg);
    }
    
    .reverse .rear-side {
      opacity: 1;
      transform: rotateY(0deg);
    }
    .reverse .front-side {
      opacity: 0;
      transform: rotateY(180deg);
    }
    </style>
    